/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_h_act_sedentary = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sedentary`)
};

const es_h_act_sedentary = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sedentario`)
};

const de_h_act_sedentary = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sitzend`)
};

const nl_h_act_sedentary = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zittend`)
};

const fr_h_act_sedentary = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sédentaire`)
};

const it_h_act_sedentary = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sedentario`)
};

const pt_br2_h_act_sedentary = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sedentário`)
};

const pt_h_act_sedentary = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sedentário`)
};

const ja_h_act_sedentary = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`座り仕事中心`)
};

const zh_h_act_sedentary = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`久坐`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const h_act_sedentary = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.h_act_sedentary(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("h_act_sedentary", locale)
	if (locale === "en") return en_h_act_sedentary(inputs)
	if (locale === "es") return es_h_act_sedentary(inputs)
	if (locale === "de") return de_h_act_sedentary(inputs)
	if (locale === "nl") return nl_h_act_sedentary(inputs)
	if (locale === "fr") return fr_h_act_sedentary(inputs)
	if (locale === "it") return it_h_act_sedentary(inputs)
	if (locale === "pt-BR") return pt_br2_h_act_sedentary(inputs)
	if (locale === "pt") return pt_h_act_sedentary(inputs)
	if (locale === "ja") return ja_h_act_sedentary(inputs)
	return zh_h_act_sedentary(inputs)
};